"use client";
import { useEffect, useState } from "react";
import Script from "next/script";
import { getStoredConsent, type CookieConsentValue } from "@/components/marketing/svendetid-landing/CookieConsent";

const GA_MEASUREMENT_ID = "G-SW0R0F8JLB";

export default function GoogleAnalytics() {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    setEnabled(getStoredConsent()?.analytics === true);

    const onConsentChange = (e: Event) => {
      const detail = (e as CustomEvent<CookieConsentValue>).detail;
      setEnabled(detail?.analytics === true);
    };
    window.addEventListener("cookie-consent-changed", onConsentChange);
    return () => window.removeEventListener("cookie-consent-changed", onConsentChange);
  }, []);

  if (!enabled) return null;

  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`}
        strategy="afterInteractive"
      />
      <Script id="google-analytics" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${GA_MEASUREMENT_ID}');
        `}
      </Script>
    </>
  );
}
